const NOTIFICATIONS = {
	LOGOUT: 'imaios-logout-notification',
	IS_REQUIRING_REFRESH_USER_INFO: 'is-requiring-refresh-user-info',
	LOGIN_MANAGER_READY: 'login-manager-ready',
	USER_INFORMATIONS_AVAILABLE: 'user-informations-available',
	SIQ_INFORMATION_RESOLVED: 'siq-information-resolved',
	SIQ_SCRIPT_LOADED: 'siq-script-loaded'
};

export default NOTIFICATIONS;
